import { useEffect, useState } from "react";
import FileUploader from "../../../components/FileUploader";

const MedicalPostDocProofs = ({translation, docData, setCurrentStep, postSlug, isUpdate}) => {

  const [uploadedMedicalBill, setUploadedMedicalBill] = useState(false);
  const [oldMedicalBill, setOldMedicalBill] = useState(null);
  
  const [uploadedEetectricFile, setUploadedEetectricFile] = useState(false);
  const [oldElectricBill, setOldElectricBill] = useState(null);

  useEffect(()=>{
    if (docData){
      setOldMedicalBill(docData?.documents?.medical_bill)
      setOldElectricBill(docData?.documents?.electric_bill)

      setUploadedMedicalBill(true)
      setUploadedEetectricFile(true)
    }
  }, [docData])
  

  return (
    <>
      <form onSubmit={()=>{setCurrentStep("submit_view_post")}} className="pt-3 pb-6 space-y-4">
        {/* Electric Bill Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="medical_bill" className="block font-semibold mb-2 dark:text-white">
            {translation.other.medical_bill_pic}
          </label>

          <FileUploader
            fileNameInDB={'medical_bill'}
            key="medical_bill_uploader"
            allowedTypes={['jpeg', 'jpg', 'png', 'bmp', 'webp', 'heic', 'heif', 'pdf']}
            onSuccess={(filePath)=>{
              setUploadedMedicalBill(true);
              setOldMedicalBill(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.medical_bill_description}
            showPreview={oldMedicalBill ? `${process.env.REACT_APP_CDN_URL}/${oldMedicalBill}` : null} 

          />
        </div>


        {/* Electric Bill Upload */}
        <div className="flex flex-col space-y-1">
          <label htmlFor="electric_bill" className="block font-semibold mb-2 dark:text-white">
            {translation.other.elect_bill_name}
          </label>

          <FileUploader
            fileNameInDB={'electric_bill'}
            key="electric_file_uploader"
            allowedTypes={['jpeg', 'jpg', 'pdf', 'png', 'bmp', 'webp', 'heic', 'heif']}
            onSuccess={(filePath)=>{
              setUploadedEetectricFile(true);
              setOldElectricBill(filePath)
            }}
            generateUrlEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/generate-presigned-url/`}
            updateBackendEndpoint={`${process.env.REACT_APP_BACKEND_DOMAIN}/post/upload-post-docs/`}
            additionalFormData={{'slug': postSlug}}
            maxSizeMB={100}
             
            awsUploadDestination={'posts/username/docs'}
            description={translation.other.electric_bill_description}
            showPreview={oldElectricBill ? `${process.env.REACT_APP_CDN_URL}/${oldElectricBill}` : null} 

          />
        </div>

        {/* Submit Button */}
        <div className="flex space-x-3">
            {isUpdate && 
              <button
                onClick={()=>{
                  setCurrentStep("attach_video_proofs");
                }}
                className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 "
              >
                {translation.back}
              </button> 
            }

            <button
              type="submit"
              className="w-full rounded-md bg-blue-500 text-white font-extrabold px-4 py-2 hover:bg-blue-600 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed"
              disabled={ !uploadedMedicalBill || !uploadedEetectricFile}
            >
              {translation.next}
            </button>
        </div>
      </form>
    </>
  )
}

export default MedicalPostDocProofs;